import { GridCellProps } from '@progress/kendo-react-grid';
import { TextBoxChangeEvent } from '@progress/kendo-react-inputs';
import { useCallback, useMemo } from 'react';
import GridCellBase, { useGridCellDisplayValue } from 'src/components/GridCellBase';
import NumberInput from 'src/components/NumberInput';
import useDelayedInputOnchange from 'src/hooks/useDelayedInputOnchange';
import { InvoiceContext } from 'src/sections/invoice_details/InvoiceDetailsContext';
import { getBgColor } from 'src/utils/icons';
import { useContextSelector } from 'use-context-selector';

const InvoicePercentageCell = (props: GridCellProps) => {
  const distributionType = useContextSelector(InvoiceContext, (value) => value.distributionType);
  const hasDistributionPermission = useContextSelector(
    InvoiceContext,
    (value) => value.hasDistributionPermission
  );
  const { dataItem } = props;
  const { displayValue } = useGridCellDisplayValue(props);
  const { handleChange, value } = useDelayedInputOnchange(props);
  const handlePercentageChange = useCallback(
    (e: TextBoxChangeEvent) => {
      e.value =
        typeof e.value === 'string' && e.value.trim() === '' ? '' : Math.abs(Number(e.value));
      handleChange(e);
    },
    [handleChange]
  );
  const error = useMemo(
    () => dataItem?.errors?.percentageAmount || [],
    [dataItem?.errors?.percentageAmount]
  );

  if (!hasDistributionPermission || distributionType !== 'Percentage') {
    return (
      <GridCellBase {...props} title={`${displayValue}%`}>
        <p className="text-left">{displayValue}%</p>
      </GridCellBase>
    );
  }

  return (
    <GridCellBase {...props} title={`${displayValue}%`} className={getBgColor(error)}>
      <NumberInput
        value={value}
        onChange={handlePercentageChange}
        postfix="%"
        valid={!error?.length}
      />
    </GridCellBase>
  );
};

export default InvoicePercentageCell;
